import { FC } from 'react'

type Props = {
  fill?: string
  opacity?: number
}

export const DoubleCircleIcon: FC<Props> = ({ fill = '#060725', opacity = 1 }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" opacity={opacity}>
      <circle cx="7" cy="7" r="6.5" stroke={fill} />
      <circle cx="7" cy="7" r="3" fill={fill} />
    </svg>
  )
}
